import { render } from "./credits.vue?vue&type=template&id=4e2a4f9f"
import script from "./credits.vue?vue&type=script&lang=js"
export * from "./credits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__